import { Card, CardHeader, Typography } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export const EventInsightsCard = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation('visualisation');
  return (
    <Card>
      <CardHeader>
        <Typography variant="headingMedium" as="h2">
          {t('insights')}
        </Typography>
      </CardHeader>
      {children}
    </Card>
  );
};
